/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';

export interface ISubmitButtonProps {
  title?: string;
  onNextButtonPress?(): void;
}

export const NextButton = (props: ISubmitButtonProps) => {
  const { title, onNextButtonPress } = props;
  return (
    <Row>
      <Col xs={12}>
        <Button
          onClick={onNextButtonPress}
          className="text-dark me-3 mt-2 mb-2"
          size="lg"
          variant="secondary"
          style={{ float: 'right' }}
        >
          {title}
        </Button>
      </Col>
    </Row>
  );
};

NextButton.defaultProps = {
  title: 'Next',
};
